export type CardSubtitlePart = {
  label: string;
  value: string;
};

export function PatientV2CardSubtitle({ parts }: { parts: CardSubtitlePart[] }) {
  const visible = parts.filter((part) => {
    const value = String(part.value ?? "").trim();
    return value && value !== "—";
  });

  if (!visible.length) return null;

  return (
    <p className="mt-0.5 truncate text-[14px] leading-snug text-muted-foreground">
      {visible.map((part, index) => (
        <span key={`${part.label}-${index}`}>
          {index > 0 ? <span aria-hidden="true"> · </span> : null}
          <span className="text-[#111827]">{part.label}:</span>{" "}
          <span>{part.value}</span>
        </span>
      ))}
    </p>
  );
}
